import * as React from 'react'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

import * as consent from '@owl-nest/consent'
import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'
import * as env from '@owl-nest/config'

import * as UFE from '../../../../UFE'

type AdviceModalProps = {
  ctaText?: string
  description?: string
  imageSrc?: string
  link: string
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  videoHtml?: string
}

export function AdviceModal({
  ctaText,
  description,
  imageSrc,
  link,
  open,
  setOpen,
  title,
  videoHtml,
}: AdviceModalProps): React.ReactElement<AdviceModalProps> {
  const userConfig = env.useUserEnv()

  return (
    <>
      {createPortal(
        <plume.Modal
          open={open}
          closable
          onClose={() => setOpen(false)}
          buttons={[
            {
              type: 'buttonAsLink',
              props: {
                href: link,
                children: ctaText ?? t('Edit'),
              },
            },
            {
              type: 'linkAsButton',
              props: {
                kind: 'secondary',
                onClick: () => setOpen(false),
                children: t('Later'),
              },
            },
          ]}
        >
          <ModalWrapper>
            <Center>
              <plume.styles.heading.S>{title}</plume.styles.heading.S>
              {description && <plume.styles.copy.S.regular>{description}</plume.styles.copy.S.regular>}
              {imageSrc && <Image src={imageSrc} alt={''} />}
            </Center>
            {videoHtml && (
              <plume.VideoLoader
                consentWall={consent.media.Wall}
                placeholder={userConfig.lang === 'fr' ? UFE.IMAGES?.hint?.fr : UFE.IMAGES?.hint?.en}
                videoHtml={videoHtml}
              />
            )}
          </ModalWrapper>
        </plume.Modal>,
        document.getElementById('modal-container') ?? document.body,
      )}
    </>
  )
}

const Center = styled.span`
  display: block;
  margin: 0 auto;
  text-align: center;
`

const ModalWrapper = styled.div`
  ${plume.styles.heading.S} {
    margin-bottom: 15px;
  }
`

const Image = styled.img`
  width: 100%;
  margin-top: 11px;
`
